<template>
  <div>
    <div class="box">
      <video 
        ref="videoPlayer"
       @play="startTimer" @pause="stopTimer" @ended="onEnded"
        :src="info.url"
        controls
      ></video>
      <div>
        <div class="title">{{ info.name }}</div>
        <div class="tips">
          <div class="tip">主讲人：{{ info.speaker }}</div>
          <div class="tip">{{ info.studyTime }}学时</div>
          <div class="tip">{{ info.studyCount }}人学习</div>
          <div class="tip" v-if="info.finishDruation >= info.duration">进度：已学完</div>
          <div class="tip" v-else>进度：{{ info.finishDruation || 0 }}/{{ info.duration }}</div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { getCourseDetail, saveCourse } from "@/api/index";
export default {
  data() {
    return {
      info: {},
      timer: null,                // 定时器
      elapsedTime: 0,             // 已经过的时间
      lastSavedTime: 0,           // 上次保存的时间
      isPaused: false,            // 视频是否暂停
      isContinue: false,
      xmId: ''
    }
  },
  created() {
    this.xmId =  this.$route.query.xmId || ''
    getCourseDetail(this.$route.query).then(res => {
      this.info = res
    })
  },
  methods: {
   startTimer() {
      if (this.info.finishDruation == null) {
        this.callApi()
      }
      const video = this.$refs.videoPlayer;

      if (this.info.finishDruation > 0 && this.info.finishDruation < this.info.duration && !this.isContinue) {
        this.isContinue = true
        video.currentTime = this.info.finishDruation * 60;
      }

      // 如果定时器没有启动，启动定时器
      if (!this.timer && this.info.finishDruation < this.info.duration) {
        this.timer = setInterval(() => {
          // 每次定时器触发时，增加已过时间
          this.elapsedTime += 1;

          // 每60秒执行一次接口请求
          if (this.elapsedTime - this.lastSavedTime >= 60) {
            this.callApi(this.elapsedTime);  // 调用接口
            this.lastSavedTime = this.elapsedTime; // 更新上次保存的时间
          }
        }, 1000);  // 每秒检查一次
      }
    },
    onPause() {
      // 视频暂停时，记录当前已过的时间
      this.isPaused = true;
      this.clearTimer();  // 停止定时器
    },
    stopTimer() {
      // 视频结束时，停止定时器
      this.clearTimer();
    },
    onEnded() {
      this.clearTimer();
      if (this.info.finishDruation +1 == this.info.duration) {
        this.callApi()
      }
    },
    clearTimer() {
      // 停止定时器
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    callApi(currentTime) {
      // 执行接口请求
      console.log(`接口请求发送，已过时间：${currentTime}s`);
      saveCourse({ id: this.$route.query.id, flag: 1, xmId: this.xmId }).then(res => {
        if (res == 0 || this.info.finishDruation == null) {
          this.info.finishDruation = 0
        } else {
          this.info.finishDruation += 1
        }
      })
      // 你可以在这里做实际的 API 请求，比如：
      // axios.post('/your-api-endpoint', { time: currentTime });
    }
  },
  beforeDestroy() {
    // 在组件销毁时清除定时器
    this.clearTimer();
  },
}
</script>

<style lang="scss" scoped>
.box {
  padding: 30px 24px 32px 24px;
  background-color: #fff;
}

video {
  width: 100%;
  height: 648px;
}

.title {
  font-weight: 500;
  font-size: 18px;
  color: #1A1A1A;
  line-height: 24px;
  margin-bottom: 12px;
}

.tips {
  display: flex;
  gap: 20px;

  .tip {
    padding: 0 6px;
    line-height: 24px;
    background: #EEEEEE;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    color: #767676;
  }
}
</style>
